/* Black Friday collection template (bfc-* sections). One delegated script,
   safe to load once per section:
     [data-bfc-countdown]   data-end (ISO date-time); cells [data-u="d|h|m|s"];
                            data-on-end="hide" hides it at zero
     [data-bfc-copy]        copies its value; button text → data-copied for 1.5s
     [data-bfc-chips]       filter chips for the grid named by aria-controls:
                            chip data-ids (product ids; shows exactly those
                            cards in that order, other rules ignored), or the
                            rules below. Cards: [data-bfc-extra] only for their
                            ids chip, [data-bfc-pool] hidden under "All",
                            [data-bfc-own] ("All" list only) skipped by rules;
                            data-words (comma-separated title words, any
                            match), data-mf-ref + data-mf-values (metafield
                            "ns.key" read from the card's data-mf JSON; value
                            contains any of the comma-separated values, or
                            just has a value when none given), data-tag (product tag handle), data-max
                            (price in cents); all given must match; none = all
     form[data-bfc-atc]     AJAX add to cart, then opens the theme cart drawer */
(function () {
  if (window.__bfcSale) return;
  window.__bfcSale = true;

  var pad = function (n) { return (n < 10 ? '0' : '') + n; };

  /* ---------- countdowns ---------- */
  function tick() {
    var els = document.querySelectorAll('[data-bfc-countdown]');
    var now = Date.now();
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var end = el._bfcEnd || (el._bfcEnd = Date.parse(el.getAttribute('data-end')));
      if (isNaN(end)) continue;
      var s = Math.max(0, Math.floor((end - now) / 1000));
      var v = { d: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60), s: s % 60 };
      var cells = el.querySelectorAll('[data-u]');
      for (var j = 0; j < cells.length; j++) {
        var t = pad(v[cells[j].getAttribute('data-u')]);
        if (cells[j].textContent !== t) cells[j].textContent = t;
      }
      if (s === 0 && el.getAttribute('data-on-end') === 'hide' && !(window.Shopify && window.Shopify.designMode)) el.hidden = true;
    }
  }
  tick();
  setInterval(tick, 1000);

  /* ---------- copy code ---------- */
  function copy(btn) {
    var code = btn.getAttribute('data-bfc-copy');
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', label);
    var done = function () {
      btn.textContent = btn.getAttribute('data-copied') || label;
      clearTimeout(btn._t);
      btn._t = setTimeout(function () { btn.textContent = label; }, 1500);
    };
    var fallback = function () {
      var ta = document.createElement('textarea');
      ta.value = code; ta.setAttribute('readonly', ''); ta.style.position = 'fixed'; ta.style.opacity = '0';
      document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } catch (e) {}
      ta.remove(); done();
    };
    if (navigator.clipboard && window.isSecureContext) navigator.clipboard.writeText(code).then(done, fallback);
    else fallback();
  }

  /* ---------- filter chips ---------- */
  function filter(chip) {
    var bar = chip.closest('[data-bfc-chips]');
    var grid = bar && document.getElementById(bar.getAttribute('aria-controls'));
    if (!grid) return;
    var chips = bar.querySelectorAll('.bfc-chip');
    for (var i = 0; i < chips.length; i++) chips[i].setAttribute('aria-pressed', String(chips[i] === chip));
    var tag = (chip.getAttribute('data-tag') || '').toLowerCase();
    var words = (chip.getAttribute('data-words') || '').split(',')
      .map(function (w) { return w.trim(); }).filter(Boolean);
    var max = parseInt(chip.getAttribute('data-max'), 10);
    var ids = (chip.getAttribute('data-ids') || '').split(',').filter(Boolean);
    var mfRef = chip.getAttribute('data-mf-ref');
    var mfVals = (chip.getAttribute('data-mf-values') || '').split(',')
      .map(function (w) { w = w.trim(); return w === 'yes' ? 'true' : w === 'no' ? 'false' : w; }).filter(Boolean);
    var rules = !!(tag || words.length || mfRef || !isNaN(max));
    var cards = grid.querySelectorAll('[data-bfc-card]');
    var shown = 0;
    for (var k = 0; k < cards.length; k++) {
      var c = cards[k];
      var ok = true;
      var pos = ids.indexOf(c.getAttribute('data-id'));
      if (ids.length) ok = pos > -1;
      else if (c.hasAttribute('data-bfc-extra')) ok = false;
      else if (!rules) ok = !c.hasAttribute('data-bfc-pool');
      else ok = !c.hasAttribute('data-bfc-own');
      c.style.order = ids.length && ok ? pos : '';
      if (ids.length) { c.hidden = !ok; if (ok) shown++; continue; }
      if (ok && tag) ok = ('|' + (c.getAttribute('data-tags') || '') + '|').indexOf('|' + tag + '|') > -1;
      if (ok && words.length) {
        var title = c.getAttribute('data-title') || '';
        ok = words.some(function (w) { return title.indexOf(w) > -1; });
      }
      if (ok && mfRef) {
        if (!c._mf) { try { c._mf = JSON.parse(c.getAttribute('data-mf') || '{}'); } catch (e) { c._mf = {}; } }
        var mv = c._mf[mfRef] || '';
        ok = mfVals.length ? mfVals.some(function (w) { return mv.indexOf(w) > -1; }) : (mv !== '' && mv !== 'false');
      }
      if (ok && !isNaN(max)) ok = parseInt(c.getAttribute('data-price'), 10) <= max;
      c.hidden = !ok;
      if (ok) shown++;
    }
    /* the feature card only shows with the unfiltered list */
    var feats = grid.querySelectorAll('[data-bfc-feature]');
    for (var f = 0; f < feats.length; f++) feats[f].hidden = !!(ids.length || rules);
    var empty = grid.querySelector('[data-bfc-empty]');
    if (empty) empty.hidden = shown > 0;
  }

  /* ---------- add to cart ---------- */
  function addToCart(form) {
    var btn = form.querySelector('button[type="submit"]');
    var orig = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-adding') || orig; }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (data) {
        if (btn) btn.textContent = btn.getAttribute('data-added') || orig;
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .catch(function (err) {
        if (btn) btn.textContent = btn.getAttribute('data-error') || orig;
        document.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          detail: { errorMessage: (err && (err.description || err.message)) || 'Error adding to cart' }
        }));
      })
      .then(function () {
        setTimeout(function () { if (btn) { btn.textContent = orig; btn.disabled = false; } }, 2000);
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var cp = t.closest && t.closest('[data-bfc-copy]');
    if (cp) { copy(cp); return; }
    var chip = t.closest && t.closest('[data-bfc-chips] .bfc-chip');
    if (chip && chip.tagName === 'BUTTON') { filter(chip); }
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('form[data-bfc-atc]');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });
})();
